var render, staticRenderFns
var script = {}
import style0 from "./Home.native.vue?vue&type=style&index=0&id=518d1e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d1e22",
  null
  
)

export default component.exports